import {AmAsset} from './models/am-asset.model';
import {Operator} from './models/operator.model';

/**
 * serice will holed sharable data between the different components
 */
export default class AmStoreService {
  constructor(gettext) {
    'ngInject';
    this.assets = [];
    this.operators = [];
    this.CODE_SYNC_MAP = {
      pending: {label: gettext('Pending'), iclass: ''},
      failed: {label: gettext('Failed'), iclass: ''},
      success: {label: gettext('Successful'), iclass: ''}
    };
    this.viewedOperator = null;
    this.viewedAsset = null;
  }
  get CodeTypes() {
    const CODE_TYPE_ENUM = {
      PIN: 'PIN',
      ZTR_RFID: 'ZTR_RFID',
      IPAF: 'IPAF'
    };
    return CODE_TYPE_ENUM;
  }
  getStore() {
    return this;
  }
  updateAssets(assetData = []) {
    this.assets = assetData.map(asset => new AmAsset(asset));
  }
  updateOperators(operatorsData = []) {
    this.operators = operatorsData.map(oprerator => new Operator(oprerator));
  }
  setVeiwedOperator(operator) {
    this.viewedOperator = operator;
  }
}
